module.exports = __webpack_public_path__ + "img/mwi.6073ddcf.svg";